import { useState } from 'react';

// Common form state management
export function useFormState(initialState = {}) {
  const [formData, setFormData] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" or "error"
  const [isInitializing, setIsInitializing] = useState(true);

  const updateFormData = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const resetForm = () => {
    setFormData(initialState);
    setMessage("");
    setMessageType("");
  };

  const showMessage = (msg, type = "success") => {
    setMessage(msg);
    setMessageType(type);
  };

  const setLoading = (loading) => {
    setIsLoading(loading);
  };

  const setInitializing = (initializing) => {
    setIsInitializing(initializing);
  };

  return {
    formData,
    updateFormData,
    resetForm,
    isLoading,
    setLoading,
    message,
    messageType,
    showMessage,
    isInitializing,
    setInitializing
  };
}

// Common loading component - now imported from LoadingComponent
export { LoadingSpinner } from './LoadingComponent';

// Common form validation
export const validators = {
  username: (username) => {
    if (username.length < 3) {
      return "Username must be at least 3 characters long.";
    }
    return null;
  },
  
  password: (password, minLength = 6) => {
    if (password.length < minLength) {
      return `Password must be at least ${minLength} characters long.`;
    }
    return null;
  },
  
  confirmPassword: (password, confirmPassword) => {
    if (password !== confirmPassword) {
      return "Passwords do not match.";
    }
    return null;
  }
};
